const HiddenComponent = () => {
  return <></>;
};

export default HiddenComponent;
